export interface SiteSettings {
  site_name: string;
  payment_method: PaymentMethodConfig;
  currency: CurrencyConfig;
  ads_manager: AdsManager;
  analytics: AnalyticsConfig;
  language?: LanguageSettingsResponse;

}

// --- Idiomas de contenido del site (settings/v2) ---
// Forma cruda tal cual la devuelve el backend (snake_case, igual que el resto de este DTO).
export interface SiteLanguageResponse {
  iso_code: string;
  label: string;
  native_name: string;
  rtl: boolean;
  // ISO 3166-1 alpha-2 del país representativo (ej. "us", "br") para la bandera. null si no aplica.
  country_code?: string | null;
}

export interface LanguageSettingsResponse {
  default_language: SiteLanguageResponse;
  supported: SiteLanguageResponse[];
}

// Forma de aplicación (camelCase) que consumen LanguageService y el selector de idioma.
// Se deriva de SiteLanguageResponse vía toSiteLanguage() — nunca se guarda duplicada en
// el estado, solo se calcula en los selectores de SiteSettingState.
export interface SiteLanguage {
  isoCode: string;
  label: string;
  nativeName: string;
  rtl: boolean;
  countryCode?: string | null;
}

export function toSiteLanguage(raw: SiteLanguageResponse): SiteLanguage {
  return {
    isoCode: raw.iso_code,
    label: raw.label,
    nativeName: raw.native_name,
    rtl: raw.rtl,
    countryCode: raw.country_code ?? null,
  };
}



export interface AnalyticsConfig {
  internal_analytics_id: string;
  custom_analytics_id: string;
}


export interface AdsManager {
  pixels: Pixel[];
}
export interface Pixel {
  id: string;
  platform: AdsPlateform;
}

export enum AdsPlateform {
  META = "META",
  TIKTOK = "TIKTOK",
  PINTEREST = "PINTEREST",
  GOOGLE = "GOOGLE",
  SNAPCHAT = "SNAPCHAT",
  X = "X"
}



// Configuración de métodos de pago
export interface PaymentMethodConfig {
  default_config: PaymentMethodDetails;
  all: PaymentMethodDetails[];
}

// Objeto i18n aplanado que devuelve el backend: { default_value, en, es, fr, ar, ... }
export interface I18nLabelResponse {
  default_value: string;
  [lang: string]: string;
}

// Detalles de cada método de pago
export interface PaymentMethodDetails {
  id: string;
  platform: string;
  enabled: boolean;
  payment_default: boolean;
  attributes?: PaymentAttributes; // Opcional, ya que no todos los métodos lo tienen
  // Etiqueta/descripción traducidas y agnósticas al gateway, desde el maestro del
  // backend. El cliente ve "Tarjeta de crédito/débito", nunca "Stripe".
  label?: I18nLabelResponse;
  description?: I18nLabelResponse;
}

// Atributos específicos del método de pago (pueden variar por plataforma)
export interface PaymentAttributes {
  publicKey?: string; // Para STRIPE
  clientId?: string; // Para PAYPAL
  clientSecret?: string; // Para PAYPAL
  live?: string; // Para PAYPAL
}

// Configuración de moneda
export interface CurrencyConfig {
  default_config: CurrencyDetails;
  all: CurrencyDetails[];
}

// Detalles de cada moneda
export interface CurrencyDetails {
  id: string;
  label: {
    default_value: string;
  };
  code: string;
  symbol: string;
}
